import { render, staticRenderFns } from "./TabGoogle.vue?vue&type=template&id=0f9ea122&scoped=true"
import script from "./TabGoogle.vue?vue&type=script&lang=ts"
export * from "./TabGoogle.vue?vue&type=script&lang=ts"
import style0 from "./TabGoogle.vue?vue&type=style&index=0&id=0f9ea122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ea122",
  null
  
)

export default component.exports